// Shared motion primitives for hover/press states.
//
// react-native-web forwards `transition*` style props straight through as real
// CSS, so a style object swapped by Pressable's `hovered`/`pressed` state eases
// between the two instead of snapping. On native these keys are simply ignored,
// so the same styles stay valid there.
//
// Cast to any: they're web-only extensions and aren't in RN's ViewStyle type.

export const transition = (
  duration = 180,
  properties = 'transform, box-shadow, background-color, opacity, border-color',
) =>
  ({
    transitionProperty: properties,
    transitionDuration: `${duration}ms`,
    transitionTimingFunction: 'cubic-bezier(0.2, 0.8, 0.3, 1)',
  } as any);

/** Card/tile lift used on hover across the dashboard. */
export const hoverLift = (distance = 3, scale?: number) =>
  ({
    transform: scale
      ? [{translateY: -distance}, {scale}]
      : [{translateY: -distance}],
    shadowColor: '#262322',
    shadowOpacity: 0.14,
    shadowRadius: 16,
    shadowOffset: {width: 0, height: 8},
  } as any);

/** Press feedback that pairs with `hoverLift` — settles back down, no opacity flicker. */
export const pressSink = (scale = 0.985) =>
  ({
    transform: [{translateY: 0}, {scale}],
  } as any);
